import { Injectable } from '@angular/core';
import { DispatchedServiceViewModel } from 'src/app/driver/models/view-models/dispatched-service.view-model';
import { OrderedServicesService } from '../core/ordered-services.service';
import { map, Observable } from 'rxjs';

/**
 * Query class for getting could not complete dispatched services.
 */
@Injectable({
	providedIn: 'root'
})
export class CannotCompleteServicesQueryService {
	/**
	 * @constructor
	 *
	 * @param orderedServicesService The service used to get ordered services hydrated with state data.
	 */
	constructor(
		private readonly orderedServicesService: OrderedServicesService
	) { }

	/**
	 * Gets the list of dispatched services that could not be completed in order.
	 * @returns An Observable emitting an array of `DispatchedServiceViewModel` instances representing all dispatched services that could not be completed.
	 */
	public GetCouldNotCompletedServices$(): Observable<DispatchedServiceViewModel[]> {
		return this.orderedServicesService.GetOrderedServices$().pipe(
			map((services: DispatchedServiceViewModel[]) => services
			.filter((service: DispatchedServiceViewModel) => service.AcceptedDate != null && service.HasDriverCouldNotComplete && !service.HasDriverCompleted)
			.sort((a, b) => Date.parse(a.CannotCompleteDate!.toString()) - Date.parse(b.CannotCompleteDate!.toString())))
		);
	}
}
